export {
  COST_AREA_OPTIONS,
  COST_BEHAVIOR_OPTIONS,
  COST_NATURE_OPTIONS,
  COST_TRACEABILITY_OPTIONS,
  CURRENCY_OPTIONS,
  getOptionLabel,
} from '../../constants/financeConstants';

export const INVOICE_STATUS_LABELS = {
  draft: 'Borrador',
  open: 'Pendiente',
  partially_paid: 'Pago parcial',
  paid: 'Pagada',
  cancelled: 'Anulada',
};
